import React from "react";

function LeadOrder({ formData, setFormData, buttonStyle, selected, formRow }) {
  const handleOrderChange = (value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      order_status: value,
    }));
  };

  const orderOptions = [
    { value: 'order_placed', label: "Order Placed" },
    { value: 'order_not_placed', label: "Order not Placed" },
  ];

  return (
    <div className="my-3">
      <div className='d-flex align-itms-center justify-content-between border-bottom border-1 p-2'>
        <h4 className='flex-1 align-self-center p-0 m-0'>Lead Order</h4>
        <div className={`${formRow} flex-1`}>
          {orderOptions.map((option) => (
            <p
              key={option.value}
              className={formData.order_status === option.value ? selected : buttonStyle}
              onClick={() => handleOrderChange(option.value)}
            >
              {option.label}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
}

export default LeadOrder;